<template>
  <div id="app">
    <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
    />

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap" rel="stylesheet">
    <CalculateForm
     v-show="!results && !error"
      @onResults="onResults"
      @onError="onError" />
    <ErrorResult v-if="error"/>
    <CalculatorResults
      v-if="results"
      :results="results"
      @onResults="onResults"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import VueMask from 'v-mask';

import CalculateForm from './components/CalculatorForm'
import CalculatorResults from './components/CalculatorResults'
import ErrorResult from './components/ErrorResult'

Vue.use(VueMask);

export default {
  name: 'App',
  components: {
    CalculateForm,
    CalculatorResults,
    ErrorResult
  },
  data() {
    return {
      results: null,
      error: false,
    }
  },
  methods: {
    onResults(results) {
      this.results = results;
    },
    onError(resultError) {
      this.error = resultError;
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200');
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

#app {
  font-family: Lato, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 669px;
  margin: 0 auto;
}


.material-icons {
    font-family: 'Material Symbols Outlined', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    vertical-align: middle;
}
::v-deep .material-symbols-outlined {
  font-family: 'Material Symbols Outlined', Arial, Helvetica, sans-serif !important;
}
label {
  margin: 0 !important;
  display: initial !important;
}
</style>
